import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { ShippingProviderFormData } from "@/formTypes/ShippingProviderFormDataType";

export type ShippingProviderDataType = Partial<ApiSchema["ShippingProvider"]["type"] & ShippingProviderFormData>;

class Api extends GenericModelApi<"ShippingProvider", ShippingProviderDataType> {
    /** Etiqueta `codigo - nombre`: el usuario busca al courier por cualquiera de los dos. */
    async optionsList(
        filters: any = {},
        labelGenerator?: (item: ShippingProviderDataType) => string,
        valueProp: keyof ShippingProviderDataType = "id",
    ): Promise<Record<string, string>> {
        return super.optionsList(
            filters,
            labelGenerator || ((provider) => `${provider.codigo || ""} - ${provider.nombre || ""}`),
            valueProp,
        );
    }
}

export const ShippingProviderApi = new Api("ShippingProvider", "nombre", "ASC");
